import { useEffect, useState } from 'react';
import {
  loadLocalVolume,
  notifyVolumeGesture,
  publishLocalAudio,
  subscribeLocalAudio,
} from '../../lib/localVolume';
import '../SyncPlayer.css';

export default function ViewerVolume() {
  const [{ volume, muted }, setAudio] = useState(loadLocalVolume);

  useEffect(() => subscribeLocalAudio(setAudio), []);

  function changeVolume(next: number) {
    const level = Math.max(0, Math.min(100, Math.round(next)));
    setAudio(publishLocalAudio({ volume: level, muted: level > 0 ? false : muted }));
    notifyVolumeGesture();
  }

  function toggleMute() {
    setAudio(publishLocalAudio({ volume, muted: !muted }));
    notifyVolumeGesture();
  }

  const shown = muted ? 0 : volume;

  return (
    <div className="viewer-volume">
      <button
        className="viewer-volume-mute"
        type="button"
        onClick={toggleMute}
        aria-label={muted || volume === 0 ? 'Unmute' : 'Mute'}
      >
        {muted || volume === 0 ? '🔇' : volume < 40 ? '🔈' : volume < 75 ? '🔉' : '🔊'}
      </button>
      <input
        className="viewer-volume-slider"
        type="range"
        min={0}
        max={100}
        value={shown}
        onChange={(event) => changeVolume(Number(event.target.value))}
        aria-label="Your volume"
      />
      <span className="viewer-volume-level">{shown}%</span>
    </div>
  );
}
